import { FC, useEffect, useState } from "react"
import { NoProps } from "../../shared/types"
import { Logger } from "../../shared/Logger"
import { getThreads, ThreadSummary } from "../../services/BoardData"
import TagBubble from "../../widgets/TagBubble"
import ThreadSearchBox from "./ThreadSearchBox"
import NavlinkOutline from "../../widgets/NavlinkOutline"

type State = {
  threads: ThreadSummary[],
  isSearching: boolean,
  isError: boolean,
  errorText?: string
}

const initialState: State = {
  threads: [],
  isSearching: true,
  isError: false,
}

const Board: FC<NoProps> = () => {
  Logger.debug('board render')
  const [state, setState] = useState(initialState)
  useEffect(() => {
    getThreads().then(threads => setState({ threads, isSearching: false, isError: false }))
      .catch(reason => setState({ threads: [], isSearching: false, isError: true, errorText: reason }))
  }, [getThreads])

  const handleSearchResults = (params: { data: Array<ThreadSummary>, isSearching: boolean, errorText: string }) => {
    setState({ threads: params.data, isSearching: params.isSearching, isError: !!params.errorText, errorText: params.errorText })
  }

  return (
    <div className="container mx-auto">
      {<div className="flex align-left">
        <div className=""><ThreadSearchBox handleSearchResults={handleSearchResults} /></div>
        <div className="ml-10 p-2 flex"><NavlinkOutline toPath={"/board-help"} linkText={"help"} /></div>
      </div>}
      {<div className="mb-10 flex"><NavlinkOutline toPath={"/new-thread"} linkText={"post a new thread"} /></div>}
      {state?.isSearching && <div className="my-10">getting the stuff...</div>}
      {!state?.isSearching && !state?.threads?.length && <div className="my-10">didn't find threads?</div>}
      {state?.isError && <div className="my-10">Error: {state.errorText}</div>}
      {!state?.isSearching && state.threads.map(getThreadSummaryLine)}
    </div>
  )
}

function getThreadSummaryLine(thread: ThreadSummary, index: number) {
  return (
    <div className="w-full" key={'chatline-' + index}>
      <div className="bg-white text-s font-bold flex items-center">
        <a href={"thread/" + thread.id}>{thread.title}</a>
        {(thread.tags || []).map((tag, idx) => <TagBubble key={'thread-' + thread.id + '-tags-' + idx} bubbleText={tag} />)}
      </div>
      <div className="text-xs font-light">
        {' '}
        {thread.authorHandle}
        {' '}
        {thread.createDate.toLocaleDateString(undefined, {
          dateStyle: 'long'
        })}
      </div>
    </div>
  )
}


export default Board